import {
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    showErrorMessage,
    convertUniversalDateTimeToPersianDateTime,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    RaikoCollapsibleTable,
    RaikoCustomTooltip
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useAuthState} from "../../context/AuthContext";
import {AccountService} from "../../serverService/account/AccountService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useNavigate} from "react-router-dom";
import AccountCheckoutDetail from "./AccountCheckoutDetail";

export default function AccountCheckout() {

    let page = 0
    const size = 25

    const {fundID} = useAuthState()

    const service = new AccountService()

    const navigate = useNavigate()

    useEffect(() => {
        getCheckoutRequests()
    }, [fundID]);

    function prepareRowItem(number, id, fullName, accountNumber, accountId, changedStatusBy, changedStatusAt, sendAt, sendBy, status) {
        return {
            number,
            id,
            fullName,
            accountNumber,
            date: convertUniversalDateTimeToPersianDateTime(sendAt),
            submitBy: sendBy,
            status: status === "AWAITING_FOR_REVIEW" ?
                <RaikoCustomSimpleChip title={"در انتظار بررسی"}
                                       type={RaikoChipTypes.warning}
                /> :
                status === "ACCEPTED" ?
                    <RaikoCustomSimpleChip
                        title={"پذیرفته شده"}
                        type={RaikoChipTypes.success}
                    /> :
                    <RaikoCustomSimpleChip
                        title={"رد شده"}
                        type={RaikoChipTypes.error}
                    />,
            access: <div
                className={css`
                    display: flex;
                    justify-content: center;
                    gap: .5rem;`}>

                <RaikoCustomTooltip title={"جزئيات حساب"}>
                    <div
                        className={"ic-profile"}
                        onClick={_ => {
                            navigate(
                                RouteHelper.AccountsDetail.globalUrl.replace(":id", accountId),
                                {state: {title: fullName}, replace: false}
                            )
                        }}
                    />
                </RaikoCustomTooltip>
            </div>,
            children: <AccountCheckoutDetail id={id}/>
        }
    }

    function getCheckoutRequests() {
        setTableLoading(true)
        service.getAccountCheckoutRequests(
            fundID,
            page,
            size
        ).then(response => {
            setTotalAmount(response.numberOfItems)
            setPageCount(response.totalPage)

            setCheckouts([])
            response.data.map((item, index) => {
                setCheckouts(prev => [
                    ...prev,
                    prepareRowItem(
                        (page * size) + index + 1,
                        item.id,
                        item.ownerFullName,
                        item.depositAccountNumber,
                        item.depositAccountId,
                        item.changedStatusBy,
                        item.changedStatusAt,
                        item.sendAt,
                        item.sendBy,
                        item.status
                    )
                ])
            })
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const [checkouts, setCheckouts] = useState([])
    const [tableLoading, setTableLoading] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [pageCount, setPageCount] = useState(0);


    function handleShowDetail(id) {

    }

    function handleChangePagination(newPage) {
        page = newPage
        getCheckoutRequests()
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(RouteHelper.AccountsCheckout.name, ""),
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"درخواست های تسویه حساب"}
                            subTitle={"درخواست های تسویه حساب ثبت شده توسط اعضا صندوق"}
                            amount={totalAmount}
                        />

                        <RaikoCollapsibleTable
                            header={header}
                            data={checkouts}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            rowClicked={handleShowDetail}
                            handlePaginationChange={handleChangePagination}
                            emptyListTitle={""}
                            emptyListSubtitle={""}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const header = [
    {
        id: "number",
        label: "#",
    }, {
        id: "fullName",
        label: "نام و نام خانوادگی",
    }, {
        id: "accountNumber",
        label: "شناسه حساب",
    }, {
        id: "date",
        label: "تاریخ ثبت",
    }, {
        id: "submitBy",
        label: "ثبت کننده",
    }, {
        id: "status",
        label: "وضعیت رسیدگی",
    }, {
        id: "access",
        label: "دسترسی ها",
    },
]
